export default [
    { value: 1, text: 'MON' },
    { value: 2, text: 'TUE' },
    { value: 3, text: 'WED' },
    { value: 4, text: 'THU' },
    { value: 5, text: 'FRI' },
    { value: 6, text: 'SAT' },
    { value: 7, text: 'SUN' },
];
